__turbopack_context__.v({
  "admin-bg-danger": "NotFoundHero-module-scss-module__Pg5Nwa__admin-bg-danger",
  "admin-bg-info": "NotFoundHero-module-scss-module__Pg5Nwa__admin-bg-info",
  "admin-bg-primary": "NotFoundHero-module-scss-module__Pg5Nwa__admin-bg-primary",
  "admin-bg-secondary": "NotFoundHero-module-scss-module__Pg5Nwa__admin-bg-secondary",
  "admin-bg-success": "NotFoundHero-module-scss-module__Pg5Nwa__admin-bg-success",
  "admin-bg-warning": "NotFoundHero-module-scss-module__Pg5Nwa__admin-bg-warning",
  "admin-border": "NotFoundHero-module-scss-module__Pg5Nwa__admin-border",
  "admin-border-dark": "NotFoundHero-module-scss-module__Pg5Nwa__admin-border-dark",
  "admin-border-light": "NotFoundHero-module-scss-module__Pg5Nwa__admin-border-light",
  "admin-rounded": "NotFoundHero-module-scss-module__Pg5Nwa__admin-rounded",
  "admin-rounded-full": "NotFoundHero-module-scss-module__Pg5Nwa__admin-rounded-full",
  "admin-rounded-lg": "NotFoundHero-module-scss-module__Pg5Nwa__admin-rounded-lg",
  "admin-rounded-md": "NotFoundHero-module-scss-module__Pg5Nwa__admin-rounded-md",
  "admin-rounded-sm": "NotFoundHero-module-scss-module__Pg5Nwa__admin-rounded-sm",
  "admin-shadow-lg": "NotFoundHero-module-scss-module__Pg5Nwa__admin-shadow-lg",
  "admin-shadow-md": "NotFoundHero-module-scss-module__Pg5Nwa__admin-shadow-md",
  "admin-shadow-sm": "NotFoundHero-module-scss-module__Pg5Nwa__admin-shadow-sm",
  "admin-sr-only": "NotFoundHero-module-scss-module__Pg5Nwa__admin-sr-only",
  "admin-text-light": "NotFoundHero-module-scss-module__Pg5Nwa__admin-text-light",
  "admin-text-muted": "NotFoundHero-module-scss-module__Pg5Nwa__admin-text-muted",
  "admin-text-primary": "NotFoundHero-module-scss-module__Pg5Nwa__admin-text-primary",
  "admin-text-secondary": "NotFoundHero-module-scss-module__Pg5Nwa__admin-text-secondary",
  "hero": "NotFoundHero-module-scss-module__Pg5Nwa__hero",
  "hero__container": "NotFoundHero-module-scss-module__Pg5Nwa__hero__container",
  "hero__content": "NotFoundHero-module-scss-module__Pg5Nwa__hero__content",
  "hero__message": "NotFoundHero-module-scss-module__Pg5Nwa__hero__message",
  "hero__number": "NotFoundHero-module-scss-module__Pg5Nwa__hero__number",
  "hero__overlay": "NotFoundHero-module-scss-module__Pg5Nwa__hero__overlay",
  "hero__text": "NotFoundHero-module-scss-module__Pg5Nwa__hero__text",
  "hero__vimeo-wrapper": "NotFoundHero-module-scss-module__Pg5Nwa__hero__vimeo-wrapper",
});
